export default __webpack_public_path__ + "static/media/au.664df3ce.svg";